import * as React from 'react';

import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { Res } from 'core/api';
import { PosScreenClassComponent, DialogIcon, ScreenSize, ActionButtonDefinition } from 'pos/ui';
import { Command, Electron } from 'pos/common';
import { Result } from 'core/infrastructure';
import { CashdrawerFacade } from 'pos/facades';
import { Cols, Col } from 'core/ui';
import { Message, Modal } from 'core/ui-next/modal';

type Props = Modal.Actions<string>;
type State = { password: string; };

class GetPasswordScreen extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();
	private txtPassword = React.createRef<UI.TextBox<State>>();

	createInitialState(_props: Props): Nullable<State> {
		return { password: '' };
	}

	onComponentDidMount(): void {
		this.txtPassword.current!.activate();
	}

	onComponentWillUnmount(): void { }

	protected getScreenId(): string {
		return 'CLOSE_APP';
	}

	protected getTitle(): string {
		return Res.Web.GET_PASSWORD();
	}

	protected getImage(): string | SvgIcon {
		return Images.GetPassword;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOK });
	}

	private onOK = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.password);
	};

	protected getContent(): React.ReactNode {
		const { Form, TextBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<DialogIcon className='img-circle' src={Images.Exit} />
			<Cols>
				<Col width='*' className='m-t-md'>
					<TextBox className='form-control form-control-password text-center' ref={this.txtPassword} linkTo={x => x.password} placeholder={Res.Web.GET_PASSWORD_PASSWORD_PLACEHOLDER()} autoComplete='off' required onKeyDown={UI.whenEnterKey(this.onOK)} />
				</Col>
			</Cols>
		</Form>;
	}
}

async function canCloseApp(): Promise<boolean> {

	if (!Electron.isEnabled())
		return false;

	const businessDay = await CashdrawerFacade.getCurrentBusinessDay();
	if (businessDay) {
		const result = await Message.confirm(Res.Msg.MSG_CONFIRM_EXIT_APPLICATION_WITH_DAY_OPENED());
		if (!result.ok)
			return false;
	}

	const exitPassword = await Electron.Settings.getExitPassword();
	if (exitPassword === '')
		return true;

	const result = await Modal.show(GetPasswordScreen);
	if (!result.ok)
		return false;

	return result.value === exitPassword;
}


declare global {
	interface CommandType {
		closeApp: () => Promise<Result>
	}
}

Command.register('closeApp', 'NO_PRECONDITION', async (): Promise<Result> => {

	const canClose = await canCloseApp();
	if (canClose)
		Electron.close();

	return canClose ? Result.ok() : Result.error();
});
